export const version = 'berater-v1.16.0-rc3';